import { useCallback } from 'react';

import { usePostHog } from 'posthog-js/react';
import { useInterval } from 'react-use';

export const useFeatureFlagRefresh = (refreshInterval = 10000) => {
  const posthog = usePostHog();

  const refreshFeatureFlag = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- posthog can be null when not configured
    posthog?.reloadFeatureFlags();
  }, [posthog]);

  useInterval(refreshFeatureFlag, refreshInterval);
};
